/*global __DEVELOPMENT__ */
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTopicId = exports.getCatId = undefined;

var _listId = require('../conf/list-id');

function getCatId(catName) {
  if (__DEVELOPMENT__) {
    return _listId.devCatListId[catName];
  }
  return _listId.prodCatListId[catName];
}

function getTopicId(topicName) {
  if (__DEVELOPMENT__) {
    return _listId.devTopicListId[topicName];
  }
  return _listId.prodTopicListId[topicName];
}

exports.getCatId = getCatId;
exports.getTopicId = getTopicId;


/*****************
 ** WEBPACK FOOTER
 ** ./src/utils/get-list-id.js
 ** module id = 845
 ** module chunks = 0
 **/